<template>
    <div v-if="handleSegments" class="filterConfigurador">
        <div class="closeFilter">
            <svg @click="closeModal" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.292893 0.292893C0.683417 -0.0976311 1.31658 -0.0976311 1.70711 0.292893L7 5.58579L12.2929 0.292893C12.6834 -0.0976311 13.3166 -0.0976311 13.7071 0.292893C14.0976 0.683417 14.0976 1.31658 13.7071 1.70711L8.41421 7L13.7071 12.2929C14.0976 12.6834 14.0976 13.3166 13.7071 13.7071C13.3166 14.0976 12.6834 14.0976 12.2929 13.7071L7 8.41421L1.70711 13.7071C1.31658 14.0976 0.683417 14.0976 0.292893 13.7071C-0.0976311 13.3166 -0.0976311 12.6834 0.292893 12.2929L5.58579 7L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683417 0.292893 0.292893Z" fill="#ffffff"/></svg>
        </div>
        <div class="filterConfigurador-wrap">

            <template v-for="(item,index) in filterCfgArr">
                <CheckBox v-if="item.vueComp" :key="index"
                :isDisabled='item.disabled' :field='item.field' :fieldLabel='item.label' :isChecked="item.checked"
                @checked-item="filterModels(index, item, $event)" />
                <p v-else :key="index" class="h2"> {{ item.text }} </p>
            </template>

        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import CheckBox from '../../FormFields/CheckBox/CheckBox.vue'

    export default {
        name: 'FilterConfigurador',
        components:{ CheckBox, },
        props:{
            priceRange: { type: [Object, Boolean], default: () => { return {}; }},
        },
        data(){return{
            filterCfgArr: [ //type 1: segments, 2: price, 3: rent
                { vueComp: false, text: 'Filtrar por segmentos' },
                // ...

                { vueComp: false, text: 'Filtrar por preço' },
                { vueComp: true, checked: false, disabled: false, field: 'cfg_price15', label: 'Menos de 15 000€', type: 2 },
                { vueComp: true, checked: false, disabled: false, field: 'cfg_price25', label: 'Entre 15 000€ e 25 000€', type: 2 },
                { vueComp: true, checked: false, disabled: false, field: 'cfg_price35', label: 'Entre 25 000€ e 35 000€', type: 2 },
                { vueComp: true, checked: false, disabled: false, field: 'cfg_price35up', label: 'Mais de 35 000€', type: 2 },

                { vueComp: false, text: 'Filtrar por prestação' },
                { vueComp: true, checked: false, disabled: false, field: 'cfg_rent_200', label: 'Menos de 200€', type: 3 },
                { vueComp: true, checked: false, disabled: false, field: 'cfg_rent_300', label: 'Entre 200€ e 300€', type: 3 },
                { vueComp: true, checked: false, disabled: false, field: 'cfg_rent_400', label: 'Entre 300€ e 400€', type: 3 },
                { vueComp: true, checked: false, disabled: false, field: 'cfg_rent_400up', label: 'Mais de 400€', type: 3 },
            ],
            selectedSegments: [],
            selectedPrices: [],
            selectedRents: [],
        }},
        watch: {
            priceRange: function(val){
                if(!val.minPrice || this.selectedSegments.length == 0) return
                let condArr = [
                    "(el.field == 'cfg_price15') && (val.minPrice >= 15000)",
                    "(el.field == 'cfg_price25') && (val.minPrice >= 25000)",
                    "(el.field == 'cfg_price35') && (val.minPrice >= 35000)",
                    "(el.field == 'cfg_price35up') && (val.maxPrice < 35000)",
                    "(el.field == 'cfg_rent_200') && (val.minRent >= 200)",
                    "(el.field == 'cfg_rent_300') && (val.minRent >= 300)",
                    "(el.field == 'cfg_rent_400') && (val.minRent >= 400)",
                    "(el.field == 'cfg_rent_400up') && (val.maxRent < 400)"
                ];

                this.filterCfgArr.forEach(el => {
                    condArr.forEach(cond => {
                        if(eval(cond)){
                            el.disabled = true
                            if(el.checked){
                                el.checked = false
                                if(el.field.includes('price')) this.handleSelectedOptions(this.selectedPrices, el.field)
                                if(el.field.includes('rent')) this.handleSelectedOptions(this.selectedRents, el.field)
                            }
                        }
                    })
                })
            }
        },
        computed: {
            ...mapGetters({
                getSegments: 'getModelsSegments',
            }),
            handleSegments(){
                if(this.getSegments){
                    this.getSegments.forEach((el, index) => {
                        let obj = { vueComp: true, checked: false, disabled: false, field: 'cfg_segment' + el.id, label: el.name, type: 1, id: el.id }
                        this.filterCfgArr.splice(index+1, 0, obj)
                    }); return true;
                } return false
            }
        },
        methods:{
            closeModal(){
                this.$emit('close-modal', true)
            },
            filterModels(i, item){
                this.filterCfgArr[i].checked = !this.filterCfgArr[i].checked

                if(item.type == 1){
                    this.filterCfgArr.forEach(el => el.disabled = false)
                    this.handleSelectedOptions(this.selectedSegments, item.id)
                    this.$emit('update:segments', this.selectedSegments)
                }


                if(item.type == 2){
                    this.handleSelectedOptions(this.selectedPrices, item.field)
                    this.$emit('update:prices', this.selectedPrices)
                }

                if(item.type == 3){
                    this.handleSelectedOptions(this.selectedRents, item.field)
                    this.$emit('update:rents', this.selectedRents)
                }
            },
            handleSelectedOptions(arr, opt){
                let index = arr.indexOf(opt)
                index === -1 ? arr.push(opt) : arr.splice(index, 1)
            },
        }
    }
</script>
<style lang="scss">
    @import './FilterConfigurador.scss';
</style>
